import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAll } from 'apis/organizations.api';

const useGetAll = (t, conds) => {
  const { data: organizationsData, ...rest } = useQuery(['projectProposalOrganizations'], getAll, {
    ...conds,
  });

  const organizations = useMemo(
    () =>
      organizationsData?.data?.map((e) => ({
        id: e?.id,
        name: t('lang') === 'vi' ? e?.name : e?.englishName,
      })) ?? [],
    [organizationsData, t]
  );

  return {
    data: organizations,
    ...rest,
  };
};

export default useGetAll;
